import { useCallback } from "react";
import api from "../config/api/axiosConfig";

export const useCategoryApi = () => {
  const createCategory = async (name: string) => {
    const response = await api.post("/Category", { name });
    return response;
  };

  // ✅ Get all recipes
  const getCategories = useCallback(async () => {
    const response = await api.get("/Category");
    return response;
  }, []);

  return {
    getCategories,
    createCategory,
  };
};
